import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JSON - 지역 데이터 */
import indiaArea from '../../assets/json/india-area.json';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

import { confirmAlert } from 'react-confirm-alert';

const TobAccountModal = (props) => {
  const { closeModal } = useModal();
  const isRegi = props.props?.isRegi;

  const [item, setItem] = useState({
    salesPersonId: '',
    password: '',
    passwordConfirm: '',
    salesPersonName: '',
    regionCode: '', // State
    city: '',       // City 추가
    mobileNo: '',
    accountNo: '',
    ifscCode: '',
    useYn: 'Y',
  });

  const [cityList, setCityList] = useState([]); // 선택된 Region에 따른 도시 목록
  const [isSubmit, setIsSubmit] = useState(false);
  const [isIdCheck, setIsIdCheck] = useState(!isRegi);
  const [isPhoneCheck, setIsPhoneCheck] = useState(!isRegi);

  useEffect(() => {
    if (!isRegi && props.props?.data?.item) {
      setItem(props.props.data.item);
    }
  }, [props, isRegi]);

  // Region(State) 변경 시 City 리스트 업데이트 및 자동 선택 로직
  useEffect(() => {
    if (item.regionCode) {
      const selectedData = indiaArea.find(area => area.name === item.regionCode);
      const cities = selectedData ? selectedData.cities : [];
      setCityList(cities);

      // 연방 직할령 규칙: 도시가 1개이고 주 이름과 같으면 자동 세팅
      if (cities.length === 1 && cities[0] === item.regionCode) {
        setItem(prev => ({ ...prev, city: cities[0] }));
      } else {
        // 수정 모드에서 초기 로드 시 값이 있는 경우 유지, 그 외엔 초기화
        if (Common.isEmpty(item.city) || !cities.includes(item.city)) {
          setItem(prev => ({ ...prev, city: '' }));
        }
      }
    } else {
      setCityList([]);
      setItem(prev => ({ ...prev, city: '' }));
    }
  }, [item.regionCode]);

  const validation = () => {
    const checkList = [
      { key: 'salesPersonId', msg: 'Login ID required.' },
      { key: 'salesPersonName', msg: 'Name required.' },
      { key: 'regionCode', msg: 'Region required.' },
      { key: 'city', msg: 'City required.' }, // City 검증 추가
      { key: 'mobileNo', msg: 'Phone number required.' },
      { key: 'accountNo', msg: 'Account number required.' },
      { key: 'ifscCode', msg: 'IFSC Code required.' },
    ];

    if (isRegi) {
      checkList.push(
        { key: 'password', msg: 'Password required.' },
        { key: 'passwordConfirm', msg: 'Password Confirmation required.' }
      );
    }

    for (const obj of checkList) {
      if (Common.isEmpty(item[obj.key])) {
        Common.errorMsg(obj.msg);
        return false;
      }
    }

    if (item.password !== item.passwordConfirm) {
      Common.errorMsg('Passwords do not match.');
      return false;
    }

    if (isRegi && !isIdCheck) {
      Common.errorMsg('ID verification required.');
      return false;
    }
    if (!isPhoneCheck) {
      Common.errorMsg('Phone verification required.');
      return false;
    }

    return true;
  };

  const setSalesPerson = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);
            const request = isRegi ? Server.sendPost : Server.sendPut;
            request('shopify/sales/regi', item, setSalesPersonCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };

  const setSalesPersonCallback = (res) => {
    setIsSubmit(false);
    if (res?.resultCount > 0) {
      Common.alertSuccess();
      props.props.data.callback();
      closeModal();
    } else {
      Common.errorMsg(res?.resultMessage || 'Save failed.');
    }
  };

  const checkPhone = () => {
    if (Common.isEmpty(item.mobileNo)) {
      Common.errorMsg('Phone number required.');
      return;
    }
    Server.sendGet('shopify/sales/check/phone', { mobileNo: item.mobileNo }, res => {
      if (Common.isEmpty(res?.['resultObject'])) {
        Common.errorMsg('Available.');
        setIsPhoneCheck(true);
      } else {
        Common.errorMsg('Phone number already exists.');
        setIsPhoneCheck(false);
      }
    }).then();
  };

  const checkSalesPersonID = () => {
    if (Common.isEmpty(item.salesPersonId)) {
      Common.errorMsg('ID required.');
      return;
    }
    Server.sendGet('shopify/sales/check/id', { salesPersonId: item.salesPersonId }, res => {
      if (Common.isEmpty(res?.['resultObject'])) {
        Common.errorMsg('Available.');
        setIsIdCheck(true);
      } else {
        Common.errorMsg('ID already exists.');
        setIsIdCheck(false);
      }
    }).then();
  }

  return (
    <>
      <CloseBtn onClick={closeModal} />
      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead><i /><h4>Sales Person {isRegi ? 'Registration' : 'Modify'}</h4></TitHead>
          </Title>
          <ModalForm>
            {/* 행 1: ID / Name */}
            <FormRow>
              <FormInWrapHalf>
                <label><span>* </span>ID</label>
                <InputGroup>
                  <FormInput
                    style={{ width: isRegi ? 'calc(100% - 85px)' : '100%' }}
                    type='text'
                    placeholder='Login ID'
                    value={item.salesPersonId || ''}
                    readOnly={!isRegi}
                    onChange={e => {
                      setItem({ ...item, salesPersonId: e.target.value });
                      setIsIdCheck(false);
                    }}
                  />
                  {isRegi && (
                    <BtnCheck
                      style={{ background: isIdCheck ? '#a4a4a4' : '#0072b9' }}
                      onClick={checkSalesPersonID}
                    >Check</BtnCheck>
                  )}
                </InputGroup>
              </FormInWrapHalf>
              <FormInWrapHalf>
                <label><span>* </span>Name</label>
                <FormInput
                  type='text'
                  placeholder='Enter name'
                  value={item.salesPersonName || ''}
                  onChange={e => setItem({ ...item, salesPersonName: e.target.value })}
                />
              </FormInWrapHalf>
            </FormRow>

            {/* 행 2: Password / Confirm PWD */}
            <FormRow>
              <FormInWrapHalf>
                <label><span>* </span>Password</label>
                <FormInput
                  type='password'
                  placeholder='Enter password'
                  value={item.password || ''}
                  onChange={e => setItem({ ...item, password: e.target.value })}
                />
              </FormInWrapHalf>
              <FormInWrapHalf>
                <label><span>* </span>Confirm PWD</label>
                <FormInput
                  type='password'
                  placeholder='Confirm password'
                  value={item.passwordConfirm || ''}
                  onChange={e => setItem({ ...item, passwordConfirm: e.target.value })}
                />
              </FormInWrapHalf>
            </FormRow>

            {/* 행 3: Region / City */}
            <FormRow>
              <FormInWrapHalf>
                <label><span>* </span>Region</label>
                <select
                  name='regionCode'
                  value={item.regionCode || ''}
                  onChange={e => setItem({ ...item, regionCode: e.target.value })}
                >
                  <option value="">Select Region</option>
                  {indiaArea.map((area) => (
                    <option key={area.id} value={area.name}>{area.name}</option>
                  ))}
                </select>
              </FormInWrapHalf>
              <FormInWrapHalf>
                <label><span>* </span>City</label>
                <select
                  name='city'
                  value={item.city || ''}
                  onChange={e => setItem({ ...item, city: e.target.value })}
                  disabled={!item.regionCode}
                >
                  <option value="">Select City</option>
                  {cityList.map((city, index) => (
                    <option key={index} value={city}>{city}</option>
                  ))}
                </select>
              </FormInWrapHalf>
            </FormRow>

            {/* 행 4: Phone / Account No */}
            <FormRow>
              <FormInWrapHalf>
                <label><span>* </span>Phone</label>
                <InputGroup>
                  <FormInput
                    style={{ width: 'calc(100% - 85px)' }}
                    type='text'
                    placeholder='Numbers only'
                    value={item.mobileNo || ''}
                    onChange={e => {
                      const val = Common.onlyNumber(e.target.value);
                      setItem({ ...item, mobileNo: val });
                      setIsPhoneCheck(false);
                    }}
                  />
                  <BtnCheck
                    style={{ background: isPhoneCheck ? '#a4a4a4' : '#0072b9' }}
                    onClick={checkPhone}
                  >Check</BtnCheck>
                </InputGroup>
              </FormInWrapHalf>
              <FormInWrapHalf>
                <label><span>* </span>Account No.</label>
                <FormInput
                  type='text'
                  placeholder='Account number'
                  value={item.accountNo || ''}
                  onChange={e => setItem({ ...item, accountNo: e.target.value })}
                />
              </FormInWrapHalf>
            </FormRow>

            {/* 행 5: IFSC Code */}
            <FormRow>
                <FormInWrapHalf>
                    <label><span>* </span>IFSC Code</label>
                    <FormInput
                      type='text'
                      placeholder='IFSC Code'
                      value={item.ifscCode || ''}
                      onChange={e => setItem({ ...item, ifscCode: e.target.value })}
                    />
                </FormInWrapHalf>
            </FormRow>

            <FormBtn>
              <BtnCancel type="button" onClick={closeModal}>Cancel</BtnCancel>
              <BtnSubmit type="button" $Color onClick={setSalesPerson}>Submit</BtnSubmit>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
  & i { display: block; width: 4px; height: 32px; border-radius: 0 2px 2px 0; background: #1e1e1e; }
  & h4 { font-weight: 700; font-size: 18px; color: #000000; }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;
`;

const FormRow = styled.div`
  display: flex;
  width: 100%;
  gap: 0 20px;
  margin-top: 10px;
`;

const FormInWrapHalf = styled.div`
  display: flex;
  width: 50%;
  align-items: center;
  gap: 0 10px;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;
    & span { font-size: 11px; color: red; }
  }

  & select {
    width: 70%;
    height: 40px;
    padding: 0 16px;
    background: #f8f8f8;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-size: 16px;
  }
`;

const FormInput = styled.input`
  width: 70%;
  height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  outline: none;
  font-size: 16px;
  &:focus { border-color: #0072B9; }
`;

const InputGroup = styled.div`
  display: flex;
  width: 70%;
  gap: 0 8px;
  align-items: center;
`;

const FormBtn = styled.div`
  margin-top: 25px;
  display: flex;
  gap: 0 8px;
`;

const BtnCancel = styled.button`
  flex: 1; height: 40px; border-radius: 5px; background: #a4a4a4;
  font-weight: 500; font-size: 18px; color: #ffffff;
`;

const BtnSubmit = styled.button`
  flex: 1; height: 40px; border-radius: 5px; background: #0072b9;
  font-weight: 500; font-size: 18px; color: #ffffff;
`;

const BtnCheck = styled.button`
  width: 70px; height: 40px; border-radius: 5px;
  font-weight: 500; font-size: 14px; color: #ffffff;
`;

export default TobAccountModal;
